import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { Chip } from '../utils/cases';
import QuickInquiry, { INQUIRY_OUTCOMES, INQUIRY_OUTCOME_MAP, INQUIRY_TOPIC_MAP } from './QuickInquiry';

const PERIODS = [{ d: 7, label: '7 дней' }, { d: 30, label: '30 дней' }, { d: 90, label: '90 дней' }, { d: 365, label: 'год' }];
const fmt = d => String(d).slice(8, 10) + '.' + String(d).slice(5, 7);

// Журнал обращений (кнопка «📞 Обращение» в меню): сколько людей обратилось, откуда и чем закончилось
export default function InquiriesBlock() {
  const [rows, setRows] = useState([]);
  const [days, setDays] = useState(30);
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null);
  const load = () => api.get('/inquiries', { params: { days: 365 } }).then(r => setRows(r.data)).catch(() => {});
  useEffect(() => {
    load();
    window.addEventListener('inquiry-saved', load);
    return () => window.removeEventListener('inquiry-saved', load);
  }, []);

  const since = new Date(Date.now() - days * 864e5).toISOString().slice(0, 10);
  const list = rows.filter(r => String(r.inquiry_date).slice(0, 10) >= since);
  const real = list.filter(r => r.outcome !== 'spam');
  const byOutcome = Object.fromEntries(INQUIRY_OUTCOMES.map(o => [o.key, list.filter(r => r.outcome === o.key).length]));
  const bySource = {};
  real.forEach(r => {
    const k = r.source || 'не указан';
    bySource[k] = bySource[k] || { cnt: 0, taken: 0 };
    bySource[k].cnt++;
    if (r.outcome === 'taken') bySource[k].taken++;
  });
  const del = async id => { if (window.confirm('Удалить запись?')) { await api.delete('/inquiries/' + id); load(); } };

  return (
    <div className="card" style={{ padding: 20, marginBottom: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        <div className="section-title" style={{ marginRight: 'auto' }}>Обращения (звонки, сообщения)</div>
        {PERIODS.map(p => (
          <button key={p.d} className={'btn btn-sm ' + (days === p.d ? 'btn-primary' : 'btn-secondary')} onClick={() => setDays(p.d)}>{p.label}</button>
        ))}
        <button className="btn btn-sm btn-primary" onClick={() => setAdding(true)}>📞 Записать</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(120px,1fr))', gap: 8, marginBottom: 16 }}>
        <div style={{ padding: 10, borderRadius: 8, background: '#4f6ef714', borderTop: '3px solid #4f6ef7' }}>
          <div style={{ fontSize: 22, fontWeight: 700 }}>{real.length}</div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Живых обращений</div>
        </div>
        {INQUIRY_OUTCOMES.map(o => (
          <div key={o.key} style={{ padding: 10, borderRadius: 8, background: o.color + '14', borderTop: `3px solid ${o.color}` }}>
            <div style={{ fontSize: 22, fontWeight: 700 }}>{byOutcome[o.key]}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{o.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: 20 }}>
        <div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 6 }}>Откуда (без спама)</div>
          {!real.length && <div className="empty-state">Нет записей</div>}
          {Object.entries(bySource).sort((a, b) => b[1].cnt - a[1].cnt).map(([k, v]) => (
            <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderTop: '1px solid var(--border)', fontSize: 13 }}>
              <span>{k}</span><span><b>{v.cnt}</b> · взял {v.taken}</span>
            </div>
          ))}
        </div>
        <div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 6 }}>Последние</div>
          {list.slice(0, 30).map(r => {
            const o = INQUIRY_OUTCOME_MAP[r.outcome];
            const t = INQUIRY_TOPIC_MAP[r.topic];
            return (
              <div key={r.id} style={{ display: 'flex', gap: 6, alignItems: 'center', padding: '6px 0', borderTop: '1px solid var(--border)', fontSize: 13, flexWrap: 'wrap' }}>
                <span style={{ color: 'var(--text-muted)', width: 40 }}>{fmt(r.inquiry_date)}</span>
                {o && <Chip color={o.color}>{o.label}</Chip>}
                {t && <Chip color={t.color}>{t.label}</Chip>}
                <span style={{ flex: 1, minWidth: 120 }}>{[r.name, r.phone, r.source, r.note && (r.note.length > 160 ? r.note.slice(0, 160) + '…' : r.note)].filter(Boolean).join(' · ')}{r.files?.length > 0 && ` · 📎 ${r.files.length}`}</span>
                <button className="btn-icon" title="Изменить" onClick={() => setEditing(r)}>✏</button>
                <button className="btn-icon" title="Удалить" onClick={() => del(r.id)}>✕</button>
              </div>
            );
          })}
        </div>
      </div>
      {adding && <QuickInquiry onClose={() => setAdding(false)} onSaved={load} />}
      {editing && <QuickInquiry edit={editing} onClose={() => setEditing(null)} onSaved={load} />}
    </div>
  );
}
